/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  





//   =========================================================
//   -------- Custom code ------
//     Syncs Recharge selected plan price with:
//     - Main Add To Cart button price
//     - Sticky Cart Bar price
//     Keeps Shopify theme pricing updated when Recharge options change.
//   =========================================================

  document.addEventListener('DOMContentLoaded', function () {
    function updateATCPrice() {
      try {
        const widget = document.querySelector('recharge-subscription-widget');
        if (!widget || !widget.shadowRoot) return;

        const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
        if (!upsell || !upsell.shadowRoot) return;

        const root = upsell.shadowRoot;

        const selectedInput = root.querySelector('input[name="quantityUpsellOption"]:checked');
        if (!selectedInput) return;

        const option = selectedInput.closest('.rc-quantity-upsell-option');
        if (!option) return;


        const totalPriceEl = option.querySelector('.rc-custom-total-price');
        // const comparePriceEl = option.querySelector('.rc-custom-compare-price');
        const comparePriceEl = option.querySelector('.rc-custom-total-compare-price');


        const finalPrice = totalPriceEl ? totalPriceEl.textContent.trim() : '';


        const comparePrice =
          comparePriceEl && comparePriceEl.style.display !== 'none'
            ? comparePriceEl.textContent.trim()
            : '';

        if (!finalPrice) return;

        const priceHTML = comparePrice
          ? `
            <span class="custom-atc-final-price">${finalPrice}</span>
            <span class="custom-atc-compare-price" style="text-decoration: line-through; opacity: 0.65; margin-left: 6px;">${comparePrice}</span>
          `
          : `<span class="custom-atc-final-price">${finalPrice}</span>`;

        /* =========================
           MAIN ADD TO CART BUTTON
        ========================= */

        const mainPrice = document.querySelector('.product__submit [data-product-price]');

        if (mainPrice) {
          mainPrice.innerHTML = priceHTML;
        }

        /* =========================
           STICKY CART BAR PRICE
        ========================= */

        const stickyPrice = document.querySelector('.cart-bar__product__price [data-product-price]');

        if (stickyPrice) {
          stickyPrice.innerHTML = priceHTML;
        }
      } catch (e) {
        return;
      }
    }

    function initRechargeObserver() {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget) return;

      const wait = setInterval(() => {
        if (!widget.shadowRoot) return;

        const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
        if (!upsell || !upsell.shadowRoot) return;

        clearInterval(wait);

        updateATCPrice();

        const observer = new MutationObserver(() => {
          requestAnimationFrame(updateATCPrice);
        });

        observer.observe(upsell.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });
      }, 200);
    }

    initRechargeObserver();

    setTimeout(updateATCPrice, 300);
    setTimeout(updateATCPrice, 1000);
    setTimeout(updateATCPrice, 2000);

    document.addEventListener('change', function () {
      setTimeout(updateATCPrice, 50);
      setTimeout(updateATCPrice, 200);
      setTimeout(updateATCPrice, 500);
    });
  });




//    =========================================================
//      RECHARGE SELECTED BADGE STYLING
//      ---------------------------------------------------------
//      Makes only the selected Recharge subscription badge
//      (e.g. "Save 10%", "Save 20%") display with:
//      - Black background
//      - White text
//      - Black border

//      Re-runs automatically when Recharge selection changes.
//   =========================================================

  document.addEventListener('DOMContentLoaded', function () {
    function updateRechargeBadges() {
      const widget = document.querySelector('recharge-subscription-widget');
      if (!widget || !widget.shadowRoot) return;

      const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
      if (!upsell || !upsell.shadowRoot) return;

      const root = upsell.shadowRoot;

      root.querySelectorAll('.rc-purchase-option__plan-discount-badge').forEach((badge) => {
        badge.style.background = '';
        badge.style.color = '';
        badge.style.border = '';
      });

      const selected = root.querySelector('.rc-quantity-upsell-option[rc-selected]');

      if (!selected) return;

      const badge = selected.querySelector('.rc-purchase-option__plan-discount-badge');

      if (!badge) return;

      badge.style.background = '#2A0C14';
      badge.style.color = '#fff';
      badge.style.border = '1px solid #2A0C14';
    }

    setInterval(updateRechargeBadges, 500);
  });





//   =========================================================
//   -------- Custom code ------
//   Code fix for showing price per month and compare at price and 
//   removing margin from the recharge widget on PDP
//   =========================================================
(function () {
  const PRODUCT_VARIANT_ID = '43773480534109';

  function getPriceData() {
    return window.SubscriptionWidgetConfig?.formattedPrices?.[PRODUCT_VARIANT_ID];
  }

  function getRechargeRoots() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot) return {};
    const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!upsell?.shadowRoot) return {};
    return { upsellRoot: upsell.shadowRoot };
  }

  function injectRechargeCSS(root) {
    if (!root || root.querySelector('#custom-recharge-compare-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-recharge-compare-style';
    style.textContent = `
      .rc-custom-price-wrap {
        display: flex !important;
        flex-direction: column !important;
        align-items: flex-end !important;
        gap: 4px !important;
        white-space: nowrap !important;
      }

      .rc-custom-total-price,
      .rc-custom-total-compare-price {
        display: none !important;
      }

      .rc-custom-percent-badge {
        border-radius: 7px !important;
        padding: 7px 12px !important;
        font-size: 13px !important;
        line-height: 1.1 !important;
        font-weight: 600 !important;
      }

      .rc-custom-per-month-price {
        line-height: 1.2 !important;
        font-weight: 600 !important;
      }

      .rc-custom-compare-price {
        font-size: 12px !important;
        color: #888 !important;
        text-decoration: line-through !important;
        line-height: 1.1 !important;
        font-weight: 400 !important;
      }

      .rc-quantity-upsell-option[rc-not-selected] {
        border-color: lightgrey !important;
      }

      .rc-purchase-option__recommended-badge,
      .rc-purchase-option__best-value-badge {
        left: 50% !important;
        right: auto !important;
        transform: translateX(-50%) !important;
        background: #2A0C14 !important;
        color: #fff !important;
        border-color: #2A0C14 !important;
        padding: 4px 0.5em !important;
        border-radius: 6px !important;
      }
      .rc-purchase-option__plan-discount-badge {
        display: none !important;
      }
    `;
    root.appendChild(style);
  }

  function getNumber(price) {
    return parseFloat(String(price).replace(/[^0-9.]/g, '')) || 0;
  }

  function formatMoney(amount) {
    return '$' + amount.toFixed(2);
  }

  function getMonths(planId) {
    return planId === '4670062685' ? 3 : 1;
  }

  function injectBenefitsCSS(benefits) {
    if (!benefits?.shadowRoot) return;

    benefits.shadowRoot.querySelectorAll('p').forEach((p) => {
      p.style.setProperty('margin', '0', 'important');
    });

    const wrapper = benefits.shadowRoot.querySelector('.rc-benefits__list');

    if (wrapper) {
      wrapper.style.setProperty('margin-top', '-25px', 'important');
      wrapper.style.setProperty('margin-left', '-30px', 'important');
    }
  }

  function injectOneTimeDrawbacksCSS(drawbacks) {
    if (!drawbacks?.shadowRoot) return;

    const wrapper = drawbacks.shadowRoot.querySelector('.rc-benefits__list');

    if (wrapper) {
      wrapper.style.setProperty('margin-left', '-30px', 'important');
    }

    
  }

  function updateOption(option, priceData) {
    const input = option.querySelector('.rc-quantity-upsell-option__input');
    const header = option.querySelector('.rc-quantity-upsell-option__header');
    const priceEl = header?.lastElementChild;

    if (!input || !header || !priceEl) return;

    const planId = input.value;
    const isOneTime = !planId;

    let totalPrice = priceData.unit;
    let totalComparePrice = '';
    let perMonthPrice = priceData.unit;
    let perMonthComparePrice = '';
    let savePercent = '';
    let saveAmount = ''; 

    if (!isOneTime && priceData.sellingPlans?.[planId]) {
      const plan = priceData.sellingPlans[planId]; 
      const months = getMonths(planId);

      savePercent = `${plan.discountValue}%`;
      saveAmount = plan.quantityUpsell?.totalDiscountAmount || '';

      totalPrice = plan.quantityUpsell?.totalDiscountedPrice || plan.price;
      totalComparePrice = formatMoney(getNumber(priceData.unit) * months);

      perMonthPrice = formatMoney(getNumber(totalPrice) / months) + '/month';
      perMonthComparePrice = priceData.unit;

      const badge = option.querySelector('.rc-purchase-option__plan-discount-badge');
      if (badge && saveAmount) badge.textContent = `Save ${saveAmount}`;

      const benefits = option.querySelector('rc-benefits'); 
      if (benefits?.shadowRoot) {
        const firstP = benefits.shadowRoot.querySelector('p strong');
        if (firstP) firstP.textContent = `FREE SHIPPING + SAVE ${savePercent}`;
      }
    }

    if (!priceEl.querySelector('.rc-custom-price-wrap')) {
      priceEl.innerHTML = `
        <span class="rc-custom-price-wrap">
          <span class="rc-custom-total-price"></span>
          <span class="rc-custom-total-compare-price"></span>
          <span class="rc-custom-percent-badge"></span>
          <span class="rc-custom-per-month-price"></span>
          <span class="rc-custom-compare-price"></span>
        </span>
      `;
    }

    priceEl.querySelector('.rc-custom-total-price').textContent = totalPrice;
    priceEl.querySelector('.rc-custom-total-compare-price').textContent = totalComparePrice;

    const percentBadge = priceEl.querySelector('.rc-custom-percent-badge');
    percentBadge.textContent = saveAmount ? `Save ${saveAmount}` : '';
    percentBadge.style.display = savePercent ? 'inline-flex' : 'none';

    if (option.hasAttribute('rc-selected')) {
      percentBadge.style.background = '#2A0C14';
      percentBadge.style.color = '#fff';
    } else {
      percentBadge.style.background = '#F5EEE6'; // beige
      percentBadge.style.color = '#2A0C14';
    }

    priceEl.querySelector('.rc-custom-per-month-price').textContent = perMonthPrice;

    const compareEl = priceEl.querySelector('.rc-custom-compare-price');
    compareEl.textContent = perMonthComparePrice;
    compareEl.style.display = perMonthComparePrice ? 'block' : 'none';

    injectBenefitsCSS(option.querySelector('rc-benefits'));
    injectOneTimeDrawbacksCSS(option.querySelector('rc-onetime-drawbacks'));
  }

  function updateRechargeOptions() {
    const priceData = getPriceData();
    if (!priceData) return;

    const { upsellRoot } = getRechargeRoots();
    if (!upsellRoot) return;

    injectRechargeCSS(upsellRoot);

    upsellRoot.querySelectorAll('.rc-quantity-upsell-option').forEach((option) => {
      updateOption(option, priceData);
    });
  }

  setInterval(updateRechargeOptions, 700);
})();






(function () {
  let autoSelectDone = false;

  function selectOneMonthPlan() {
    if (autoSelectDone) return;

    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget?.shadowRoot) return;

    const upsell = widget.shadowRoot.querySelector('recharge-quantity-upsell');
    if (!upsell?.shadowRoot) return;

    const root = upsell.shadowRoot;

    const oneMonthInput = root.querySelector('input[value="4670095453"]');
    if (!oneMonthInput) return;

    const oneMonthOption = oneMonthInput.closest('.rc-quantity-upsell-option');
    if (!oneMonthOption) return;

    if (!oneMonthInput.checked || !oneMonthOption.hasAttribute('rc-selected')) {
      oneMonthInput.click();
      oneMonthInput.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }

    autoSelectDone = true;
  }

  const interval = setInterval(selectOneMonthPlan, 300);

  setTimeout(function () {
    clearInterval(interval);
  }, 6000);
})();





//   =========================================================
//   -------- Custom code ------
//   Code fix for streched product image in the recharge cart drawer
//   =========================================================
(function() {

  function fixRechargeCartImages() {
    const host = document.querySelector('#recharge-storefront-experiences__cart-drawer');

    if (!host?.shadowRoot) return;

    host.shadowRoot.querySelectorAll('#cart-drawer img').forEach((img) => { 
      img.style.objectFit = 'cover';
      img.style.height = 'auto';
    });
  }

  setInterval(fixRechargeCartImages, 1000);

})();







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
